import { lista_padrao_callbacks } from "@/components/Diagnostico/AnaliseEstoque/AnaliseQualitativaDoEstoque/EndPointAPI.js";
import store from "@/store";

const state = {
  callbacks_grid_principal: lista_padrao_callbacks,
  filtros_grid_principal: {
    segmentos: [],
    compradores: [],
    fornecedores: [],
    produtos: [],
    status_produto: [],
    histogramas: [],
    order_by: ['valor_data_final', 'up'],
    limite_linhas_por_nivel: 1000,
  }
};

const getters = {
  callbacksGridPrincipal(state) {
    return state.callbacks_grid_principal
  },
  filtrosGridPrincipal(state) {
    return {
      ...store.getters["filtrosUniversalAvancado/filtros_formatados"],
      ...state.filtros_grid_principal
    };
  },
  orderBy(state) {
    return state.filtros_grid_principal.order_by
  },
  limiteLinhasPorNivel(state) {
    return state.filtros_grid_principal.limite_linhas_por_nivel
  },
};

const mutations = {
  callbacksGridPrincipal(state, payload) {
    state.callbacks_grid_principal = payload;
  },
  filtrosGridPrincipal(state, payload) {
    state.filtros_grid_principal = payload;
  },
  orderBy(state, payload) {
    state.filtros_grid_principal.order_by = payload;
  },
  limiteLinhasPorNivel(state, payload) {
    state.filtros_grid_principal.limite_linhas_por_nivel = payload;
  },
};

const actions = {
  callbacksGridPrincipal: ({ commit }, payload) => {
    commit("callbacksGridPrincipal", payload);
  },
  filtrosGridPrincipal: ({ commit }, payload) => {
    commit("filtrosGridPrincipal", payload);
  },
  orderBy: ({ commit }, payload) => {
    commit("orderBy", payload);
  },
  limiteLinhasPorNivel: ({ commit }, payload) => {
    commit("limiteLinhasPorNivel", payload);
  },
};

export default { namespaced: true, state, mutations, getters, actions };
